import {AnyAction} from 'redux';
import Types from '../../actions/Types';

import Character from '../../../domain/entities/Character';

export default function reducer(
  state: {[key: number]: Character} = {},
  action: AnyAction,
): {[key: number]: Character} {
  switch (action.type) {
    case Types.ResetWriterCurrentUser:
      return {};
    case Types.IndexCharactersSuccess:
      return {
        ...state,
        ...action.payload.records.reduceRight(
          (obj: {[key: number]: Character}, record: Character) => {
            obj[record.id] = record;
            return obj;
          },
          {},
        ),
      };
    case Types.ShowCharacterSuccess:
    case Types.CreateCharacterSuccess:
    case Types.UpdateCharacterSuccess:
      return {
        ...state,
        [action.payload.id]: action.payload,
      };
    case Types.DestroyCharacterSuccess: {
      const deleteState = {...state};
      delete deleteState[action.payload.id];
      return deleteState;
    }
    default:
      return state;
  }
}
